import { Link as GatsbyLink } from 'gatsby';
import React from 'react';

import { Helmet } from 'react-helmet';

import styled from 'styled-components';

import SEOImage from '../../assets/images/epv_canal.jpg';
import Icon from '../../assets/images/job_ad_thumbnail.png';
import Logo from '../../assets/images/logo.svg';
import LogoBorder from '../../assets/images/logo-border.jpeg';
import Favicon from '../../assets/images/favicon.png';

import { media } from './Device';
import { connect } from 'react-redux';
import {
  mapDispatchToProps,
  mapStateToProps,
} from '../../store';

const HeaderWrapper = styled.div`
  background-color: white;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 5;
  transition: all 0.3s ease-in-out;

  &.not-scrolled {
    background-color: transparent;

    ul li a {
      color: white;
      text-shadow: 0px 0px 2px black;

      &.active {
        color: white;
      }
    }
  }

  ${media.tablet`
    &.not-scrolled {
      background-color: white;
      text-shadow: none;
      
      ul li a {
        color: #999;
        text-shadow: none;
      }
    }
  `}
`;

const Container = styled.div`
  padding: 20px 40px 20px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1600px;
  margin: 0 auto;

  .logo {
    height: 60px;
    transform-origin: center;
    position: relative;
    transition: transform 0.3s ease-in-out;

    &:hover,
    &:focus {
      transform: rotate(-5deg);
    }
  }

  img {
    width: 60px;
    height: 60px;
    margin: 0;
    position: relative;
  }

  ul li {
    display: inline-block;
    margin-left: 30px;

    .job-link {
      font-weight: 400;

      span {
        background-color: #07bd72;
        color: white;
        width: 26px;
        height: 26px;
        display: inline-flex;
        border-radius: 3px;
        margin-left: 5px;
        font-weight: 600;
        align-items: center;
        justify-content: center;
      }
    }

    &:hover,
    &:focus {
      a {
        color: #e1171e;
      }
    }

    a {
      transition: color 0.3s ease-in-out;
      color: #999;
      font-weight: 400;

      &.active {
        color: #e1171e;
      }
    }
  }

  ${media.tablet`
    padding: 20px;
    
    .logo {
      &:hover,
      &:focus {
        transform: rotate(0deg);
      }
    }
    
    ul {
      margin-left: auto; 
    
      li {
        display: none;
        
        &:hover,
        &:focus {
          a {
            color: #999;
          }
        }
        
        &.job-nav {
          display: block;
          margin: 0 80px;
        }
      }
    }
  `};
`;

const MobileNav = styled.div`
  display: none;

  > img {
    position: fixed;
    top: 20px;
    left: 20px;
    height: 60px;
    width: auto;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }

  ${media.tablet`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-color: #e1171e;
    z-index: 6;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    pointer-events: none;
    transform: scale(0.9) rotate(-5deg);
    transition: all 0.3s ease-in-out;
    
    &.mobile-nav-open {
      opacity: 1;
      pointer-events: all;
      transform: scale(1) rotate(0deg);
      
      > img {
        opacity: 1;
        transition: opacity 0.3s 0.3s ease-in-out;
      }
      
    }
    
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      text-align: center;
      
      li {
        list-style: none;
        margin: 20px 0;
        
        a {
          color: white;
          font-size: 36px;
          text-transform: uppercase;
          font-weight: 900;
          
          &.active {
            color: transparent !important;
            -webkit-text-stroke-width: 2px;
            -webkit-text-stroke-color: white;
            letter-spacing: 1px;
          }
        }
      }
    }
  `}
`;

const Hamburger = styled.a`
  display: none;

  ${media.tablet`
    display: block;
    height: 60px;
    width: 60px;
    background-color: #e1171e;
    position: fixed;
    z-index: 7;
    top: 20px;
    right: 20px;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    
    &.mobile-nav-open {
      background-color: white;
      
      &:after {
        content: '\\e907';
        color: #e1171e;
      }
    }
    
    &:after {
      font-family: "Iconfont" !important;
      content: '\\e903';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      font-size: 20px;
    }
  `}
`;

const Link = props => {
  return <GatsbyLink activeClassName={'active'} {...props} />;
};

class Header extends React.Component {
  render () {
    let data = this.props.data.site.siteMetadata;

    function mobileNav () {
      document.getElementById('hamburger').classList.toggle('mobile-nav-open');
      document.getElementById('mobile-nav').classList.toggle('mobile-nav-open');
      document.body.classList.toggle('no-scroll');
    }

    return (
      <div>
          <Helmet defaultTitle={data.title} titleTemplate={`%s | ${data.title}`}>
            <html lang="en" />
            <link
              rel="canonical"
              href={`${data.siteUrl}${this.props.pathname}`}
            />
            
            <meta name="docsearch:version" content="2.0" />
            <meta
              name="viewport"
              content="width=device-width,initial-scale=1,shrink-to-fit=no,viewport-fit=cover"
            />

            <meta property="og:url" content={data.siteUrl} data-react-helmet="true" />
            <meta property="og:type" content="website" data-react-helmet="true" />
            <meta property="og:locale" content="en" data-react-helmet="true" />
            <meta property="og:site_name" content={data.title} data-react-helmet="true" />
            <meta property="og:title" content={data.title} data-react-helmet="true" />
            <meta property="og:description" content={data.description} data-react-helmet="true" />
            <meta property="og:image" content={'https://join.picnic.app/epv_canal.jpg'} data-react-helmet="true" />

            <meta property="twitter:title" content={data.title} data-react-helmet="true" />
            <meta property="twitter:description" content={data.description} data-react-helmet="true" />
            <meta property="twitter:image" content={'https://join.picnic.app/epv_canal.jpg'} data-react-helmet="true" />

            <meta property="image" content={'https://join.picnic.app/epv_canal.jpg'} data-react-helmet="true" />
            <link rel="shortcut icon" type="image/png" href={Favicon} />
          </Helmet>

        <Hamburger id={'hamburger'} onClick={mobileNav} />

        <MobileNav id={'mobile-nav'}>
          <img src={LogoBorder} alt="picnic-spock" />

          <ul>
            <li>
              <Link onClick={mobileNav} to={'/'}>
                Home
              </Link>
            </li>

            <li>
              <Link onClick={mobileNav} to={'/jobs'}>
                Jobs
              </Link>
            </li>

            <li>
              <Link onClick={mobileNav} to={'/events'}>
                Events
              </Link>
            </li>

            <li>
              <a target={'_blank'} href="https://hiring.picnic.app/">
                Tech Recruitment Experience
              </a>
            </li>
          </ul>
        </MobileNav>

        <HeaderWrapper className={this.props.headerClass} id={'header-nav'}>
          <Container>
            <Link className={'logo'} to="/">
              <img src={Logo} alt="picnic-logo" />
            </Link>

            <ul className={'no-list'}>
              <li>
                <Link to="/">Home</Link>
              </li>

              <li className={'job-nav'}>
                <Link className={'job-link'} to="/jobs">
                  Jobs<span>{this.props.jobNum}</span>
                </Link>
              </li>

              <li>
                <Link to="/events">Events</Link>
              </li>

              <li>
                <a target={'_blank'} href="https://hiring.picnic.app/">
                  Tech Recruitment Experience
                </a>
              </li>
            </ul>
          </Container>
        </HeaderWrapper>
      </div>
    );
  }
}

const ConnectedHeader = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header);

export { ConnectedHeader as Header };
